import React from 'react';
import ReactDOM from 'react-dom';
export const Overlay = ({ closeHandler }) => {
    return ReactDOM.createPortal(React.createElement("div", { className: "pos:f z:650 l:0 t:0 h:100p w:100p bg:overlay cursor:pointer", onClick: closeHandler }), document.body);
};
